export default __webpack_public_path__ + "static/media/background.e05e89b7.jpg";